import { post } from "../../../../shared/data";

export const removeDuplicates = (data, prop) => {
    let map = new Map();
    data.forEach((element) => {
        map.set(element[prop], element);
    });

    var filteredData = [];
    map.forEach((value, key, i) => {
        filteredData.push(value);
    });

    return filteredData;
};

export const saveNewOption = (text, url, tags) => {
    const payload = { text: text };

    if (tags) {
        payload["tag"] = typeof tags === "string" ? tags : tags[0];
    }

    return post(url, payload);
};
